import { Checkbox, Space, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export interface BudgetCategoryBudgetSettingsProps {
  isBudgetOverageEnabled: boolean
  onBudgetOverageChange: () => void
}

export const BudgetCategoryBudgetSettings = ({
  isBudgetOverageEnabled,
  onBudgetOverageChange,
}: BudgetCategoryBudgetSettingsProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space direction='vertical' size='small'>
      <Text bold>{intl.formatMessage(messages.budgetOverageHeader)}</Text>
      <Space direction='horizontal' size='medium' align='baseline'>
        <Checkbox
          aria-label={intl.formatMessage(messages.budgetOverageCheckboxLabel)}
          checked={isBudgetOverageEnabled}
          onClick={onBudgetOverageChange}
          title={intl.formatMessage(messages.budgetOverageCheckboxTitle)}
        />
        <Text>{intl.formatMessage(messages.budgetOverageDescriptionText)}</Text>
      </Space>
    </Space>
  )
}

BudgetCategoryBudgetSettings.displayName = 'BudgetCategoryBudgetSettings'
